
import React from 'react';
import { Plus } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';

interface ProfileAvatarDisplayProps {
  profilePictureUrl?: string | null;
  initials: string;
  onUploadClick?: () => void;
  onProfilePictureClick: () => void;
}

const ProfileAvatarDisplay: React.FC<ProfileAvatarDisplayProps> = ({
  profilePictureUrl,
  initials,
  onUploadClick,
  onProfilePictureClick
}) => {
  return (
    <div className="relative mx-auto">
      <div 
        className="
          h-24 w-24 
          rounded-full overflow-hidden
          flex items-center justify-center
          bg-gradient-to-br from-purple-400 to-indigo-500
          shadow-lg border-4 border-white/20 dark:border-gray-800/40
        "
      >
        {profilePictureUrl ? (
          <motion.div 
            className="h-full w-full overflow-hidden cursor-pointer"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            onClick={onProfilePictureClick}
          >
            <img 
              src={profilePictureUrl} 
              alt="Profile" 
              className="h-full w-full object-cover"
            />
          </motion.div>
        ) : (
          <span className="text-white font-medium">{initials}</span>
        )}
      </div>

      {/* Upload button */}
      {onUploadClick && (
        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
          <motion.div
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >
            <Button 
              onClick={onUploadClick} 
              variant="outline" 
              size="icon" 
              className="h-8 w-8 rounded-full bg-background border-border shadow-md hover:bg-gradient-to-br hover:from-purple-400 hover:to-indigo-500 hover:text-white"
            >
              <Plus size={14} />
              <span className="sr-only">Upload picture</span>
            </Button>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default ProfileAvatarDisplay;
